<template>
  <v-autocomplete
    v-model="selectedTags"
    :items="list"
    item-text="name"
    item-value="term_id"
    color="#f36d62"
    item-color="#f36d62"
    :label="placeholder"
    clearable
    flat
    small-chips
    outlined
    rounded
    multiple
    chips
  >
    <template #selection="{ item }">
      <v-chip color="#f36d62" class="white--text">{{ item.name }}</v-chip>
    </template>
<!--    <template #item="{ item }">
      <v-list-item #default="{ active }">
        <v-list-item-action>
          <v-checkbox
            color="#f36d62"
            :input-value="active"></v-checkbox>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            <v-row no-gutters align="center">
              <span>{{ item.name }}</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>-->
  </v-autocomplete>
</template>
<script>
export default {
  name: "SelectTags",
  props: {
    list: {
      type: Array,
      required: true,
      default: []
    },
    placeholder: {
      type: String,
      required: true,
      default: 'Title'
    },
    tagType: {
      type: String,
      required: true,
      default: 'tag'
    }
  },
  data: () => {
    return {
      selectedTags: []
    }
  },
  watch: {
    selectedTags: function (newValue) {
      this.$emit('selected-tags', {"selectedTags": newValue, "tagType": this.tagType })
    }
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SelectTagsAutocomplete.vue